import * as React from 'react';
import { Container } from 'reactstrap';
import { withRouter } from "react-router";
import { Redirect } from "react-router";
import * as AuthStore from "../store/Auth";
import { connect } from "react-redux";
import { ApplicationState } from '../store';
import NavMenu from './NavMenu';
import Footer from './Footer';
import { message} from 'antd';
import Loader from './Loader';


type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class Layout extends React.Component<AuthProps>
{
    public state = {mobile: false, ipad: false, laptop: false, screenWidth: 0, screenHeight: 100};

    //@ts-ignore
    async UNSAFE_componentWillMount()
    {
        await this.props.getUserSession();
        this.activityWatcher();
    }

    componentWillReceiveProps(nextProps: any)
    {
        if (window.location.pathname && window.location.pathname.length > 0)
        {
            if (window.location.pathname !== '/welcome' && window.location.pathname !== '/dashboard')
            {
                localStorage.removeItem('location');
                localStorage.setItem('location', window.location.pathname);
            }                        
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions.bind(this));

        var loginForm = document.getElementById("login-form");
        if (loginForm && loginForm !== null) {
            loginForm.addEventListener("keyup", function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    var btn = document.getElementById("login-button");
                    if (btn !== null) {
                        btn.click();
                    }
                }
            });
        }

    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions.bind(this))
    }

    updateWindowDimensions()
    {
        let mobile = window.innerWidth <= 768;
        let ipad = window.innerWidth >= 768 && window.innerWidth <= 1200;
        let laptop = window.innerWidth > 1200 && window.innerWidth < 1280 || window.innerWidth === 1536;
        let widescreen = window.innerWidth > 1400 && window.innerWidth !== 1536;
        let innerheight = window.innerHeight;
        this.setState({ screenWidth: window.innerWidth, mobile, ipad, laptop, innerheight });           
        //console.log(window.innerWidth);
    }

    activityWatcher()
    {
        let el = this;
        //The number of seconds that have passed
        //since the user was active.
        var secondsSinceLastActivity = 0;

        //15 minutes. 60 x 5 = 900 seconds.
        var maxInactivity = (60 * 15);

        //Setup the setInterval method to run
        //every second. 1000 milliseconds = 1 second.
        setInterval(function ()
        {
            secondsSinceLastActivity++;            

            //if the user has been inactive or idle for longer
            //then the seconds specified in maxInactivity then log them out
            if (secondsSinceLastActivity > maxInactivity)
            {
                //Redirect the user to the log in page.
                el.props.logOut();
            }
            else
            {     
                //refresh the session every 15 seconds provided the user is still active
                if (secondsSinceLastActivity === 15)
                {
                    if (window.location.pathname !== '/welcome' && window.location.pathname !== '/dashboard')
                    {
                        el.props.refreshSession();
                    }                    
                }
                else
                {
                    //warn the user if they have been idle for a long time
                    if ((maxInactivity - secondsSinceLastActivity) === 10)
                    {
                        message.error('You have been idle for a long time and will be signed out in 10 seconds. Please move your mouse or press any key. This message will disapper in 5 seconds', 5);;
                    }
                }
            }
            

        }, 1000);

        //The function that will be called whenever a user is active
        function activity()
        {            
            //reset the secondsSinceLastActivity variable
            //back to 0
            secondsSinceLastActivity = 0;
        }

        //An array of DOM events that should be interpreted as
        //user activity.
        var activityEvents = [
            'mousedown', 'mousemove', 'keydown',
            'scroll', 'touchstart'
        ];

        //add these events to the document.
        //register the activity function as the listener parameter.
        activityEvents.forEach(function (eventName)
        {
            document.addEventListener(eventName, activity, true);
        });
    }
   
    render()
    {
        const user = this.props.appUser;  
        const { mobile, ipad, laptop, screenWidth } = this.state;

        if (user.message != null && user.message.length > 0 && !user.isAuthenticated)
        {
            message.error(user.message);
        }              

        let footer = document.getElementById("footer");
        
        if (!user.isAuthenticated)
        {
            if (window.location.pathname !== '/welcome' && window.location.pathname !== '/dashboard')
            {
                return <Redirect to="/welcome" />;
            }

            if (laptop) {
                footer.classList.remove("footer");
                footer.classList.add("footer-2");
            }
            else {
                footer.classList.remove("footer-2");
                footer.classList.add("footer");
            }

            footer.style.display = 'block';
        }
        else
        {
            let location = localStorage.getItem("location");
            if (window.location.pathname == '/welcome')
            {
                footer.classList.remove("footer-2");
                footer.classList.add("footer");

                if (location)
                {
                    return <Redirect to={location} />;
                }
                else
                {
                    return <Redirect to="/home" />;
                }
            }
        }    

        return <React.Fragment>
            {
                (user === undefined || user === null || !user.isAuthenticated || window.location.pathname == '/dashboard') ?
                    null
                    :
                    <NavMenu />
            }
            <Container>
                { this.props.children }
            </Container>       
            {/*{!ipad && <Footer />}*/}
            {
                this.props.show ?
                    <Loader />
                    :
                    null
            }            
        </React.Fragment>;
    }
}

var component =  connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Layout as any);

export default withRouter(component);
